import { render, staticRenderFns } from "./WorkflowEditor.vue?vue&type=template&id=3b014654"
import script from "./WorkflowEditor.vue?vue&type=script&lang=js"
export * from "./WorkflowEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports